import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2b571c2d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/tour.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/other/assets/css/app.css?vue&type=style&index=1&id=2b571c2d&prod&scoped=true&lang=css&external"
import style2 from "@/other/assets/css/loading.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./App.vue?vue&type=style&index=3&id=2b571c2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b571c2d",
  null
  
)

export default component.exports